/**
 * Pannello "Avvisami quando torna disponibile" (eShoopy Back in Stock).
 *
 * Un solo pannello (snippets/ltd-bis-panel.liquid, guscio del Variant Wizard)
 * aperto da qualunque elemento con [data-ltd-bis-open]: il tasto sulle card
 * esaurite della griglia e la barra sulla scheda prodotto.
 * Parla con l'App Proxy dell'app: /apps/back-in-stock/config e /subscribe.
 *
 * I tasti restano nascosti finche' l'app non risponde (html.ltd-bis-on):
 * se l'app non e' installata o raggiungibile non compare nulla di rotto.
 */
(function () {
  'use strict';
  if (window.ltdBis) return;

  var CFG_KEY = 'ltd-bis-cfg';
  var CFG_TTL = 15 * 60 * 1000;
  var panel, container, els = {};
  var cur = null;            // dati del prodotto aperto
  var selected = null;       // id variante scelta
  var lastFocus = null;
  var isOpen = false;
  var subscribed = {};       // solo in memoria, per pagina: niente falsi positivi persistenti
  var cfg = null;            // risposta di /config quando l'app e' viva
  var cfgState = 'idle';     // idle | loading | ok | fail
  var customerEmail = '';

  function $(sel, ctx) { return (ctx || panel).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || panel).querySelectorAll(sel)); }

  /* ---------- configurazione app (una volta per pagina, cache di sessione) ---------- */
  function readCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CFG_KEY) || 'null');
      if (c && c.t && Date.now() - c.t < CFG_TTL && c.cfg && typeof c.cfg === 'object') return c.cfg;
    } catch (e) {}
    return null;
  }
  function writeCache(c) {
    try { sessionStorage.setItem(CFG_KEY, JSON.stringify({ t: Date.now(), cfg: c })); } catch (e) {}
  }
  function activate(c) {
    cfg = c; cfgState = 'ok';
    document.documentElement.classList.add('ltd-bis-on');
  }
  function checkApp() {
    if (cfgState !== 'idle') return;
    var cached = readCache();
    if (cached) { activate(cached); return; }
    cfgState = 'loading';
    fetch('/apps/back-in-stock/config', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (c) {
        if (!c || typeof c !== 'object') throw 0;
        writeCache(c); activate(c);
      })
      .catch(function () { cfgState = 'idle-failed'; });
  }
  // la pagina puo' ricevere card nuove (Carica altri, filtri): ricontrolla finche' non c'e' esito
  function scan() {
    if (cfgState === 'idle' && document.querySelector('[data-ltd-bis-open]')) checkApp();
  }

  /* ---------- stato del pannello ---------- */
  function setState(s) {
    panel.setAttribute('data-state', s);
    $all('[data-show]').forEach(function (n) {
      n.hidden = (' ' + n.getAttribute('data-show') + ' ').indexOf(' ' + s + ' ') === -1;
    });
  }
  function showMsg(text, kind) {
    var m = els.msg;
    if (!text) { m.hidden = true; m.textContent = ''; m.removeAttribute('data-kind'); return; }
    m.textContent = text; m.setAttribute('data-kind', kind || 'err'); m.hidden = false;
  }

  function soldList() {
    var sold = cur.variants.filter(function (v) { return !v.a; });
    return sold.length ? sold : cur.variants;
  }
  function renderSizes() {
    var list = soldList();
    var hasOptions = cur.variants.length > 1 || (cur.variants[0] && cur.variants[0].t !== 'Default Title');
    if (!hasOptions) { els.sizesWrap.hidden = true; selected = String(cur.variants[0].id); return; }
    els.sizesWrap.hidden = false;
    var opt = (cur.optionName || panel.getAttribute('data-option-default') || '').toLowerCase();
    els.label.textContent = (panel.getAttribute('data-choose') || '').replace('%%OPT%%', opt);
    els.sizes.innerHTML = '';
    list.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bz-bis__tile';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.setAttribute('data-id', String(v.id));
      b.textContent = v.t;
      els.sizes.appendChild(b);
    });
    var pre = cur.preselect && list.filter(function (v) { return String(v.id) === String(cur.preselect); })[0];
    if (pre) selected = String(pre.id);
    else if (list.length === 1) selected = String(list[0].id);
    else selected = null;
    syncSizes();
  }
  function syncSizes() {
    $all('.bz-bis__tile', els.sizes).forEach(function (b) {
      var on = b.getAttribute('data-id') === selected;
      b.classList.toggle('selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var already = selected && subscribed[selected];
    els.submit.disabled = !!already;
    if (already) showMsg(panel.getAttribute('data-subscribed'), 'ok');
    else if (els.msg.getAttribute('data-kind') === 'ok') showMsg('');
  }

  /* ---------- apertura / chiusura ---------- */
  function open(d, trigger) {
    if (!panel || !d || !d.variants || !d.variants.length) return;
    cur = d; lastFocus = trigger || document.activeElement;
    els.img.hidden = !d.image;
    if (d.image) { els.img.src = d.image; }
    els.product.textContent = d.title || '';
    els.price.textContent = d.price || '';
    els.form.reset();
    showMsg('');
    els.submit.disabled = false;
    if (customerEmail) { els.email.value = customerEmail; els.email.readOnly = true; }
    else { els.email.readOnly = false; }
    renderSizes();
    // solo clienti registrati (impostazione dell'app) e ospite: invito ad accedere
    if (cfg && cfg.onlyLoggedIn && !customerEmail) showLogin();
    else setState('form');
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('active');
    document.body.classList.add('modal-open', 'overflow-hidden');
    isOpen = true;
    fit();
    setTimeout(function () { try { container.focus({ preventScroll: true }); } catch (e) {} }, 30);
  }
  function showLogin() {
    var u = panel.getAttribute('data-login-url') || '/account/login';
    els.login.href = u + (u.indexOf('?') === -1 ? '?' : '&') + 'return_url=' + encodeURIComponent(location.pathname + location.search);
    setState('login');
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    panel.classList.remove('active');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open', 'overflow-hidden');
    container.style.removeProperty('--bis-kb');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  // tastiera mobile: il pannello e' ancorato in basso, lo alziamo sopra la tastiera
  function fit() {
    var vv = window.visualViewport;
    if (!vv || !isOpen) return;
    var kb = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    container.style.setProperty('--bis-kb', Math.round(kb) + 'px');
  }

  function focusables() {
    return $all('button, a[href], input, [tabindex]:not([tabindex="-1"])', container).filter(function (n) {
      return !n.disabled && !n.hidden && n.offsetParent !== null;
    });
  }

  /* ---------- invio ---------- */
  function submit(e) {
    e.preventDefault();
    var email = (els.email.value || '').trim();
    if (!selected) { showMsg(panel.getAttribute('data-err-size'), 'err'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showMsg(panel.getAttribute('data-err-email'), 'err'); els.email.focus(); return; }
    if (!els.consent.checked) { showMsg(panel.getAttribute('data-err-consent'), 'err'); return; }
    var v = cur.variants.filter(function (x) { return String(x.id) === selected; })[0];
    showMsg('');
    els.submit.disabled = true;
    fetch('/apps/back-in-stock/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productId: String(cur.productId),
        variantId: String(selected),
        variantTitle: v && v.t ? String(v.t) : undefined,
        productTitle: cur.title,
        productHandle: cur.handle,
        imageUrl: cur.image || undefined,
        email: email, consent: true, channel: 'EMAIL',
        locale: document.documentElement.lang || 'it'
      })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      if (res.ok) {
        subscribed[selected] = 1;
        setState('done');
        try { container.focus({ preventScroll: true }); } catch (e2) {}
      } else if (res.j && res.j.code === 'login_required') {
        // la configurazione in cache era vecchia: l'app ora vuole clienti registrati
        cfg = cfg || {}; cfg.onlyLoggedIn = true; writeCache(cfg);
        showLogin();
      } else {
        // sempre il nostro messaggio tradotto: gli errori dell'app sono tecnici e in inglese
        showMsg(panel.getAttribute('data-err-generic'), 'err');
        els.submit.disabled = false;
      }
    }).catch(function () {
      showMsg(panel.getAttribute('data-err-generic'), 'err');
      els.submit.disabled = false;
    });
  }

  /* ---------- dati dal tasto che apre ---------- */
  function themeSelectedId() {
    var q = new URL(window.location.href).searchParams.get('variant');
    if (q) return q;
    var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return f && f.value ? f.value : null;
  }
  // l'app accetta solo URL https assoluti: normalizza "//cdn..." e "/cdn..."
  function absUrl(u) {
    if (!u) return '';
    try { return new URL(u, location.href).href; } catch (e) { return ''; }
  }
  function dataFrom(t) {
    var variants = [];
    try { variants = JSON.parse(t.getAttribute('data-variants') || '[]'); } catch (e) {}
    return {
      productId: t.getAttribute('data-product-id'),
      handle: t.getAttribute('data-product-handle'),
      title: t.getAttribute('data-product-title'),
      image: absUrl(t.getAttribute('data-product-image')),
      price: t.getAttribute('data-product-price') || '',
      optionName: t.getAttribute('data-option-name') || '',
      variants: variants,
      preselect: t.hasAttribute('data-follow-theme') ? themeSelectedId() : null
    };
  }

  function init() {
    panel = document.getElementById('ltd-bis-panel');
    if (!panel) return;
    container = $('[data-bis-container]');
    els = {
      img: $('[data-bis-img]'), product: $('[data-bis-product]'), price: $('[data-bis-price]'),
      form: $('[data-bis-form]'), sizesWrap: $('[data-bis-sizes-wrap]'), label: $('[data-bis-label]'),
      sizes: $('[data-bis-sizes]'), email: $('input[name=email]'), consent: $('input[name=consent]'),
      msg: $('[data-bis-msg]'), submit: $('[data-bis-submit]'), login: $('[data-bis-login]')
    };
    customerEmail = (panel.getAttribute('data-customer-email') || '').trim();
    // logo del negozio in alto a destra, come nel wizard
    try {
      var logo = $('[data-bis-logo]');
      var logoUrl = window.bzVwLogo || (window.BeezfyTheme && window.BeezfyTheme.settings && window.BeezfyTheme.settings.logo);
      if (logo && logoUrl) { logo.src = logoUrl; logo.alt = window.bzVwShopName || ''; logo.hidden = false; }
    } catch (e) {}

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-ltd-bis-open]');
      if (t) { e.preventDefault(); e.stopPropagation(); open(dataFrom(t), t); return; }
      if (!isOpen) return;
      if (e.target.closest('[data-bis-close]')) { e.preventDefault(); close(); return; }
      var tile = e.target.closest('.bz-bis__tile');
      if (tile && els.sizes.contains(tile)) { selected = tile.getAttribute('data-id'); showMsg(''); syncSizes(); }
    }, true);
    // scalda la foto dell'intestazione appena il dito/mouse e' sul tasto
    var warmed = {};
    function warm(e) {
      var t = e.target.closest && e.target.closest('[data-ltd-bis-open]');
      var u = t && absUrl(t.getAttribute('data-product-image'));
      if (u && !warmed[u]) { warmed[u] = 1; (new Image()).src = u; }
    }
    document.addEventListener('pointerover', warm, { passive: true });
    document.addEventListener('touchstart', warm, { passive: true });
    els.form.addEventListener('submit', submit);
    els.consent.addEventListener('change', function () { if (els.msg.getAttribute('data-kind') === 'err') showMsg(''); });
    els.email.addEventListener('input', function () { if (els.msg.getAttribute('data-kind') === 'err') showMsg(''); });

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === container)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', fit);
      window.visualViewport.addEventListener('scroll', fit);
    }
    // ritorno dalla cache del browser (tasto indietro): chiudi un eventuale pannello rimasto aperto
    window.addEventListener('pageshow', function (e) { if (e.persisted) close(); });

    scan();
    if ('MutationObserver' in window) {
      var tm = null;
      new MutationObserver(function () {
        if (cfgState !== 'idle') return;
        clearTimeout(tm); tm = setTimeout(scan, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.ltdBis = { open: open, close: close, check: checkApp };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
